import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import './styles.scss';

const ButtonModalSecondary = ({ classNames = [], ...props }) => (
    <Button {...props} classNames={['custom-btn-modal-secondary', ...classNames]} />
);

ButtonModalSecondary.propTypes = {
    classNames: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func,
};

export default ButtonModalSecondary;
